export const ROLES = {
  Agent: 'Agent',
  AgencyAdmin: 'AgencyAdmin',
  Staff: 'Staff',
  ClubAdmin: 'ClubAdmin',
  Player: 'Player',
  Organizer: 'Organizer',
  Lawyer: 'Lawyer',
  Coach: 'Coach'
};

// Only configure routes for currently active roles
export const ROLE_ROUTES = {
  [ROLES.ClubAdmin]: {
    dashboard: '/club',
    tenders: '/club/tenders'
  },
  [ROLES.Agent]: {
    dashboard: '/agent/mysquad',
    tenders: '/agent/tenders'
  },
  [ROLES.Staff]: {
    dashboard: '/staff/myclub',
    tenders: '/staff/tenders'
  },
  [ROLES.Organizer]: {
    dashboard: '/organizer',
    inbox: '/inbox'
  },
  [ROLES.Lawyer]: {
    dashboard: '/lawyer',
    tenders: '/lawyer/tenders',
    inbox: '/inbox'
  },
  [ROLES.Coach]: {
    dashboard: '/coach/myclub',
    tenders: '/coach/tenders'
  }
};

// Shared routes accessible to all roles
export const SHARED_ROUTES = [
  '/search',
  '/discovery',
  '/compare',
  '/market',
  '/news',
  '/events',
  '/organizers'
];

export const ROLE_PERMISSIONS = {
  [ROLES.Agent]: { features: [] },
  [ROLES.AgencyAdmin]: { features: [] },
  [ROLES.ClubAdmin]: { features: [] },
  [ROLES.Player]: { features: [] },
  [ROLES.Staff]: { features: [] },
  [ROLES.Lawyer]: { features: [] },
  [ROLES.Coach]: { features: [] }
};

// A "lawyer-only" user is one whose roles contain Lawyer and NO other working
// role (Agent/Agency/Staff/ClubAdmin/Coach/Organizer/Player). Used to trim
// menus down to the lawyer-relevant items. Dual-role users (e.g. Agent&Lawyer)
// are NOT lawyer-only → they keep all their menus unchanged.
export const LAWYER_FULL_MENU_ROLES = [
  ROLES.Agent,
  ROLES.AgencyAdmin,
  ROLES.Staff,
  ROLES.ClubAdmin,
  ROLES.Coach,
  ROLES.Organizer,
  ROLES.Player,
];

export const isLawyerOnlyRoles = (roles) =>
  Array.isArray(roles) &&
  roles.includes(ROLES.Lawyer) &&
  !roles.some((r) => LAWYER_FULL_MENU_ROLES.includes(r));